import axios from 'axios';
import { BASE_URL } from '@/config/const';
class LiveTalkMemberAPI {
  async get(livetalkId) {
    return await axios.get(`${BASE_URL}/v2/livetalk/member/livetalk/${livetalkId}/detail`);
  }
}

export default new LiveTalkMemberAPI();


